module.exports = __webpack_public_path__ + "assets/img/2s.4d679180.png";